import { createFileRoute } from '@tanstack/react-router';
import {
  createGroupBroadcastNewRoute,
  validateGroupBroadcastNewSearch,
} from '@/lib/route-factories/group-broadcast-route';

export const Route = createFileRoute(
  '/_authed/networks/$id/admin/broadcasts/new/',
)({
  validateSearch: validateGroupBroadcastNewSearch,
  ...createGroupBroadcastNewRoute({
    kind: 'network',
    fromId: '/_authed/networks/$id/admin/broadcasts/new/',
  }),
});
